import { createModelPermissions } from 'components/permissions/utils/model-permission-generator';

const graphicsBasePath = "/graphic-rules";

const GraphicConst = createModelPermissions({
  modelName: 'graphic_rules',
  basePath: graphicsBasePath,
  permissions: { VIEW: true, UPDATE: true, DELETE: true }
});

export default GraphicConst;
